import { render, staticRenderFns } from "./RevenueManagerPropertyActionForm.vue?vue&type=template&id=536cf63b&scoped=true&"
import script from "./RevenueManagerPropertyActionForm.vue?vue&type=script&lang=js&"
export * from "./RevenueManagerPropertyActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536cf63b",
  null
  
)

export default component.exports